<p-inputgroup>
  <p-inputgroup-addon>$</p-inputgroup-addon>
  <p-inputnumber 
    type="text" 
    pattern="[0-9]*" 
    inputmode="numeric"
    [name]="name" 
    fluid
    [(ngModel)]="value"
    [required]="isRequired" 
    [disabled]="isDisabled" 
    [min]="minimumValue"
    (ngModelChange)="currencyInputChanged($event)"
  />
</p-inputgroup>